
import Layout from "../../components/feature/Layout";
import { useState } from "react";

export default function Audit() {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [filterUser, setFilterUser] = useState('all');
  const [filterAction, setFilterAction] = useState('all');

  const auditLogs = [
    { id: 1, user: "María González", action: "Creó operación", target: "OP-2024-0156", timestamp: "2024-01-16 10:30:45", ip: "192.168.1.45", module: "Operaciones", details: "Nueva operación de importación creada para cliente Importadora del Norte S.A." },
    { id: 2, user: "Carlos Ruiz", action: "Modificó cliente", target: "CLI-002", timestamp: "2024-01-16 10:15:22", ip: "192.168.1.38", module: "CRM", details: "Actualización de datos fiscales y límite de crédito" },
    { id: 3, user: "Ana Martínez", action: "Generó reporte", target: "Operaciones Mensuales", timestamp: "2024-01-16 09:45:10", ip: "192.168.1.52", module: "Reportes", details: "Exportación de reporte en formato PDF" },
    { id: 4, user: "Roberto Sánchez", action: "Aprobó operación", target: "OP-2024-0155", timestamp: "2024-01-16 09:30:33", ip: "192.168.1.41", module: "Operaciones", details: "Cambio de estado a 'Aprobada' con autorización gerencial" },
    { id: 5, user: "Laura Fernández", action: "Registró pago", target: "TRX-001", timestamp: "2024-01-16 09:15:18", ip: "192.168.1.29", module: "ERP", details: "Pago recibido de $45,280 MXN aplicado a factura FC-2024-0089" },
    { id: 6, user: "Jorge Ramírez", action: "Creó usuario", target: "Patricia López", timestamp: "2024-01-16 08:50:05", ip: "192.168.1.10", module: "Usuarios", details: "Nuevo usuario con rol Analista" },
    { id: 7, user: "María González", action: "Subió documento", target: "OP-2024-0156", timestamp: "2024-01-16 08:30:42", ip: "192.168.1.45", module: "Operaciones", details: "Bill of Lading subido y validado" },
    { id: 8, user: "Carlos Ruiz", action: "Actualizó estado", target: "OP-2024-0154", timestamp: "2024-01-15 17:45:28", ip: "192.168.1.38", module: "Operaciones", details: "Estado cambiado de 'En Tránsito' a 'En Aduana'" },
    { id: 9, user: "Sistema", action: "Backup automático", target: "Base de datos", timestamp: "2024-01-15 03:00:00", ip: "127.0.0.1", module: "Sistema", details: "Respaldo completo de base de datos ejecutado correctamente" },
    { id: 10, user: "Ana Martínez", action: "Eliminó documento", target: "DOC-2024-0892", timestamp: "2024-01-15 16:20:15", ip: "192.168.1.52", module: "Operaciones", details: "Documento duplicado eliminado de operación OP-2024-0150" },
  ];

  const getActionColor = (action: string) => {
    if (action.includes("Creó") || action.includes("Registró") || action.includes("Subió")) return "text-[#10B981]";
    if (action.includes("Modificó") || action.includes("Actualizó") || action.includes("Aprobó")) return "text-[#2F80ED]";
    if (action.includes("Eliminó")) return "text-[#EF4444]";
    if (action.includes("Generó")) return "text-[#EAB308]";
    return "text-gray-600";
  };

  const getActionIcon = (action: string) => {
    if (action.includes("Creó")) return "ri-add-circle-line";
    if (action.includes("Modificó") || action.includes("Actualizó")) return "ri-edit-line";
    if (action.includes("Eliminó")) return "ri-delete-bin-line";
    if (action.includes("Generó")) return "ri-file-chart-line";
    if (action.includes("Aprobó")) return "ri-check-double-line";
    if (action.includes("Registró")) return "ri-money-dollar-circle-line";
    if (action.includes("Subió")) return "ri-upload-line";
    if (action.includes("Backup")) return "ri-database-line";
    return "ri-history-line";
  };

  const handleViewDetail = (log: any) => {
    setSelectedLog(log);
    setShowDetailModal(true);
  };

  const filteredLogs = auditLogs.filter(log => {
    if (filterUser !== 'all' && log.user !== filterUser) return false;
    if (filterAction !== 'all') {
      if (filterAction === 'create' && !log.action.includes('Creó') && !log.action.includes('Registró')) return false;
      if (filterAction === 'update' && !log.action.includes('Modificó') && !log.action.includes('Actualizó') && !log.action.includes('Aprobó')) return false;
      if (filterAction === 'delete' && !log.action.includes('Eliminó')) return false;
    }
    return true;
  });

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Auditoría del Sistema</h1>
            <p className="text-sm text-gray-500 mt-1">Registro de actividades y acciones de usuarios</p>
          </div>
          <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap flex items-center gap-2 cursor-pointer">
            <i className="ri-file-download-line"></i>
            Exportar Log
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Usuario</label>
              <select 
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
                className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent cursor-pointer"
              >
                <option value="all">Todos</option>
                <option value="María González">María González</option>
                <option value="Carlos Ruiz">Carlos Ruiz</option>
                <option value="Ana Martínez">Ana Martínez</option>
                <option value="Roberto Sánchez">Roberto Sánchez</option>
                <option value="Laura Fernández">Laura Fernández</option>
                <option value="Jorge Ramírez">Jorge Ramírez</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Acción</label>
              <select 
                value={filterAction}
                onChange={(e) => setFilterAction(e.target.value)}
                className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent cursor-pointer"
              >
                <option value="all">Todas</option>
                <option value="create">Creación</option>
                <option value="update">Modificación</option>
                <option value="delete">Eliminación</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Inicio</label>
              <input
                type="date"
                defaultValue="2024-01-01"
                className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Fin</label>
              <input
                type="date"
                defaultValue="2024-01-16"
                className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Acciones Hoy</p>
                <p className="text-2xl font-bold text-[#0A2A43]">127</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-history-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Usuarios Activos</p>
                <p className="text-2xl font-bold text-[#0A2A43]">14</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-user-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Operaciones Creadas</p>
                <p className="text-2xl font-bold text-[#0A2A43]">8</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-add-circle-line text-2xl text-[#114B7A]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Documentos Subidos</p>
                <p className="text-2xl font-bold text-[#0A2A43]">23</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-file-upload-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
          <div className="p-6 border-b border-gray-200 flex items-center justify-between">
            <h2 className="text-lg font-bold text-[#0A2A43]">Registro de Actividades</h2>
            <span className="text-sm text-gray-500">{filteredLogs.length} registros</span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#EAF2F8]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Usuario</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Acción</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Objetivo</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Módulo</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Fecha y Hora</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">IP</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Detalles</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredLogs.map((log) => (
                  <tr key={log.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white text-xs font-semibold">
                          {log.user.split(' ').map(n => n[0]).join('')}
                        </div>
                        <span className="text-sm font-medium text-[#0A2A43]">{log.user}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <i className={`${getActionIcon(log.action)} ${getActionColor(log.action)}`}></i>
                        <span className={`text-sm font-medium ${getActionColor(log.action)}`}>
                          {log.action}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{log.target}</td>
                    <td className="px-6 py-4">
                      <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                        {log.module}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{log.timestamp}</td>
                    <td className="px-6 py-4 text-sm text-gray-500 font-mono">{log.ip}</td>
                    <td className="px-6 py-4">
                      <button 
                        onClick={() => handleViewDetail(log)}
                        className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer"
                      >
                        <i className="ri-eye-line"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Paginación */}
          <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <p className="text-sm text-gray-500">
              Mostrando <span className="font-semibold">1-{filteredLogs.length}</span> de <span className="font-semibold">1,247</span> registros
            </p>
            <div className="flex gap-2">
              <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                Anterior
              </button>
              <button className="px-3 py-1.5 text-sm bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md cursor-pointer whitespace-nowrap">
                1
              </button>
              <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                2
              </button>
              <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                3
              </button>
              <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Detalle de Actividad */}
      {showDetailModal && selectedLog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-lg font-bold text-[#0A2A43]">Detalle de Actividad</h2>
              <button onClick={() => setShowDetailModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-semibold">
                  {selectedLog.user.split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2A43]">{selectedLog.user}</p>
                  <p className="text-xs text-gray-500">{selectedLog.timestamp}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="p-3 bg-gray-50 rounded-lg">
                  <p className="text-xs text-gray-500 uppercase">Acción</p>
                  <p className={`text-sm font-semibold mt-1 ${getActionColor(selectedLog.action)}`}>{selectedLog.action}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <p className="text-xs text-gray-500 uppercase">Objetivo</p>
                  <p className="text-sm font-semibold text-[#0A2A43] mt-1">{selectedLog.target}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <p className="text-xs text-gray-500 uppercase">Módulo</p>
                  <p className="text-sm font-semibold text-[#0A2A43] mt-1">{selectedLog.module}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-lg">
                  <p className="text-xs text-gray-500 uppercase">Dirección IP</p>
                  <p className="text-sm font-mono text-[#0A2A43] mt-1">{selectedLog.ip}</p>
                </div>
              </div>

              <div className="p-4 bg-[#EAF2F8] rounded-lg">
                <p className="text-xs text-gray-500 uppercase mb-2">Descripción</p>
                <p className="text-sm text-[#0A2A43]">{selectedLog.details}</p>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end">
              <button onClick={() => setShowDetailModal(false)} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
